import { Loader } from "src/components/loader/loader";
import { useApplicationInitializer } from "./ApplicationInitializerProvider";

export const ApplicationInitializerLoader = () => {
  const { isLoading, isInitialized } = useApplicationInitializer();
  return <Loader fullscreen visible={isLoading && !isInitialized} />;
};
